/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import Component from "@glimmer/component";
const STYLES = {
  size: {
    small: "text-[0.86em]",
    normal: "text-[1em]"
  },
  alignment: {
    center: "text-center",
    left: "text-left"
  }
};
export default class NoContentMessage extends Component {
  get size() {
    return this.args.size ?? "";
  }
  get alignment() {
    return this.args.alignment ?? "";
  }
  get style() {
    return `${STYLES.size[this.size]} ${STYLES.alignment[this.alignment]}`;
  }
}